import React from 'react';
import Courses from '../Components/Courses/Courses';

const AllCourse = () => {
  return (
    <div className='p-20'>
      <Courses/>
    </div>
  );
};

export default AllCourse;